import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  makeStyles,
  Spinner,
  tokens,
} from "@fluentui/react-components"
import type { ReactNode } from "react"
import { es } from "../i18n/es"

const useStyles = makeStyles({
  // Botón de confirmación destructiva: tokens de estado de peligro, nunca hex
  danger: {
    backgroundColor: tokens.colorStatusDangerBackground3,
    color: tokens.colorNeutralForegroundOnBrand,
    ":hover": {
      backgroundColor: tokens.colorStatusDangerBackground3Hover,
      color: tokens.colorNeutralForegroundOnBrand,
    },
    ":hover:active": {
      backgroundColor: tokens.colorStatusDangerBackground3Pressed,
      color: tokens.colorNeutralForegroundOnBrand,
    },
  },
})

export interface ConfirmDialogProps {
  open: boolean
  title: string
  message: ReactNode
  // Verbo explícito de la acción ("Drenar nodo"), nunca un "Aceptar" genérico
  confirmLabel: string
  cancelLabel?: string
  danger?: boolean
  confirming?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel = es.common.cancel,
  danger = false,
  confirming = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  const styles = useStyles()
  return (
    <Dialog
      modalType="alert"
      open={open}
      onOpenChange={(_, data) => {
        if (!data.open) onCancel()
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>{message}</DialogContent>
          <DialogActions>
            <Button appearance="secondary" disabled={confirming} onClick={onCancel}>
              {cancelLabel}
            </Button>
            <Button
              appearance="primary"
              className={danger ? styles.danger : undefined}
              disabled={confirming}
              icon={confirming ? <Spinner size="tiny" /> : undefined}
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  )
}
